// extracted by mini-css-extract-plugin
export default {"shortz_container":"Shortz_shortz_container__Mvp+F","shortz_player":"Shortz_shortz_player__nxwH7","shortz":"Shortz_shortz__lfcXY","shortz_loading":"Shortz_shortz_loading__Bxk76"};